/* motricio-interactivo.js · Motricio FR · v2 interactiva (2026-10-18)
   Motivo: Esteban pidió «más imágenes interactivas, como en tryholo». Patrones propios escritos desde cero con la
   receta de ~/.claude/skills/diseno-web/referencias/holo-movimiento.md (curva .16,1,.3,1, progreso de scroll
   suavizado, rAF que se duerme). Complementa movimiento-pro.js (no lo sustituye). Sin dependencias.
     data-mo="inclinar"   hero: el mockup se inclina con el ratón (solo ratón) y con el scroll; las etiquetas se separan
     data-mo="escalera"   mecanismo: pestañas facile / cible / défi de la fiche EQ-04, con ficha que salta
     data-mo="observe"    mecanismo: las casillas se marcan con el scroll hasta «2 sur 3 = palier suivant»; tocables
     data-mo="carrusel"   demostración: abanico que se despliega con el scroll, arrastrable, flechas y contador
     visor (#lb)          zoom al tocar la página y versión grande (data-grande) para leer la ficha en el móvil
     data-mo="cartas"     qué incluye: cartas de dominio que se giran al tocarlas
   Reglas: sin JS todo se ve (el HTML trae el estado final); con prefers-reduced-motion nada se mueve solo, pero
   todo sigue siendo usable; nada en titulares, precios ni legales; solo transform / opacity / color. */
(function () {
  'use strict';
  var d = document, W = window, raiz = d.documentElement;
  var mm = function (q) { return W.matchMedia ? W.matchMedia(q).matches : false; };
  var reducir = mm('(prefers-reduced-motion: reduce)');
  var fino = mm('(hover: hover) and (pointer: fine)');
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function clamp(x, a, b) { return Math.min(b, Math.max(a, x)); }
  function visto(el, cb, umbral) {
    if (!('IntersectionObserver' in W)) { cb(); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); cb(); } }); }, { threshold: umbral || 0.4 });
    io.observe(el);
  }
  function porFotograma(fn) { var pend = false; return function () { if (!pend) { pend = true; requestAnimationFrame(function () { pend = false; fn(); }); } }; }
  raiz.classList.add('mo-js');

  /* ---------- 1 · inclinar (hero) ---------- */
  $$('[data-mo="inclinar"]').forEach(function (el) {
    if (reducir) return;
    var obj = el.querySelector('.hero-imgbtn'), etqs = $$('.etq', el), sec = el.closest('section') || el;
    if (!obj) return;
    var meta = { rx: 0, ry: 0, mx: 0, my: 0, s: 0 }, act = { rx: 0, ry: 0, mx: 0, my: 0, s: 0 }, vivo = false;
    var PROF = [1.4, 1, 1.8], DIR = [-1, 1, -1];
    function bucle() {
      var mueve = false;
      for (var k in meta) { var dl = meta[k] - act[k]; if (Math.abs(dl) > 0.002) { act[k] += dl * 0.12; mueve = true; } else act[k] = meta[k]; }
      obj.style.transform = 'rotateX(' + (act.rx + act.s * 8).toFixed(2) + 'deg) rotateY(' + act.ry.toFixed(2) + 'deg) translateY(' + (-act.s * 16).toFixed(1) + 'px)';
      etqs.forEach(function (e, i) {
        var p = PROF[i % 3], dx = -act.mx * 12 * p + DIR[i % 3] * act.s * 22 * p, dy = -act.my * 10 * p - act.s * 26 * p;
        e.style.translate = dx.toFixed(1) + 'px ' + dy.toFixed(1) + 'px';
      });
      if (mueve) requestAnimationFrame(bucle); else vivo = false;
    }
    function arranca() { if (!vivo) { vivo = true; requestAnimationFrame(bucle); } }
    if (fino) {
      sec.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = el.getBoundingClientRect();
        var nx = clamp((e.clientX - (r.left + r.width / 2)) / r.width, -1, 1), ny = clamp((e.clientY - (r.top + r.height / 2)) / r.height, -1, 1);
        meta.ry = nx * 10; meta.rx = -ny * 8; meta.mx = nx; meta.my = ny; arranca();
      });
      sec.addEventListener('pointerleave', function () { meta.rx = meta.ry = meta.mx = meta.my = 0; arranca(); });
    }
    var alScroll = porFotograma(function () {
      var r = sec.getBoundingClientRect();
      meta.s = clamp(-r.top / Math.max(1, r.height * 0.7), 0, 1); arranca();
    });
    W.addEventListener('scroll', alScroll, { passive: true });
  });

  /* ---------- 2 · escalera de paliers (pestañas accesibles) ---------- */
  $$('[data-mo="escalera"]').forEach(function (el) {
    var tabs = $$('[role="tab"]', el), panes = $$('[role="tabpanel"]', el);
    var jeton = el.querySelector('.esc-jeton'), ilu = el.querySelector('.esc-ilu'), caja = el.querySelector('.esc-marches');
    var actual = -1, manual = false;
    function colocaJeton() {
      if (!jeton || actual < 0) return;
      var t = tabs[actual], jw = jeton.offsetWidth || 30;
      jeton.style.setProperty('--jx', (t.offsetLeft + t.offsetWidth / 2 - jw / 2) + 'px');
      jeton.style.setProperty('--jy', -(caja.offsetHeight - t.offsetTop + 6) + 'px');
      jeton.classList.add('listo');
    }
    function pon(i, foco) {
      if (i === actual) { if (foco) tabs[i].focus(); return; }
      actual = i;
      tabs.forEach(function (t, k) { var on = k === i; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
      panes.forEach(function (p, k) { p.classList.toggle('activo', k === i); });
      colocaJeton();
      if (ilu && !reducir) { ilu.classList.remove('salta'); void ilu.offsetWidth; ilu.classList.add('salta'); }
      if (foco) tabs[i].focus();
    }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { manual = true; pon(k); });
      t.addEventListener('keydown', function (e) {
        var n = { ArrowRight: k + 1, ArrowLeft: k - 1, Home: 0, End: tabs.length - 1 }[e.key];
        if (n == null) return; e.preventDefault(); manual = true; pon((n + tabs.length) % tabs.length, true);
      });
    });
    var ini = tabs.map(function (t) { return t.getAttribute('aria-selected'); }).indexOf('true');
    pon(ini < 0 ? 1 : ini);
    W.addEventListener('resize', porFotograma(colocaJeton));
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(colocaJeton);
    // Demostración una sola vez al verse: facile → cible → défi → cible. Se para si la persona toca.
    if (!reducir) visto(el, function () {
      [[0, 300], [1, 1500], [2, 2700], [1, 4100]].forEach(function (s) { setTimeout(function () { if (!manual) pon(s[0]); }, s[1]); });
    }, 0.6);
  });

  /* ---------- 3 · ce que j'observe (se marca con el scroll; tocable) ---------- */
  $$('[data-mo="observe"]').forEach(function (el) {
    var cases = $$('.obs-case', el), n = el.querySelector('.obs-n'), res = el.querySelector('.obs-res'), verd = el.querySelector('.obs-verdict');
    var manual = false, OK = res.getAttribute('data-ok'), NO = res.getAttribute('data-no');
    function cuenta() {
      var k = cases.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; }).length;
      n.textContent = k + ' sur ' + cases.length; res.textContent = k >= 2 ? OK : NO; el.classList.toggle('ok', k >= 2);
    }
    cases.forEach(function (c) {
      c.addEventListener('click', function () {
        manual = true; verd.setAttribute('aria-live', 'polite');
        c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); cuenta();
      });
    });
    if (reducir) { cuenta(); return; } // estado final del HTML: 2 sur 3
    var alScroll = porFotograma(function () {
      if (manual) return;
      var r = el.getBoundingClientRect(), vh = W.innerHeight;
      var p = clamp((vh * 0.92 - r.top) / (vh * 0.5), 0, 1), k = p < 0.25 ? 0 : p < 0.6 ? 1 : 2;
      cases.forEach(function (c, i) { c.setAttribute('aria-pressed', i < k ? 'true' : 'false'); });
      cuenta();
    });
    W.addEventListener('scroll', alScroll, { passive: true }); alScroll();
  });

  /* ---------- 4 · carrusel en abanico ---------- */
  $$('[data-mo="carrusel"]').forEach(function (el) {
    var pista = el.querySelector('.car-pista'), items = $$('.car-item', el), cartas = items.map(function (f) { return f.querySelector('.car-carta'); });
    var cuenta = el.querySelector('.car-cuenta'), ant = el.querySelector('.car-ant'), sig = el.querySelector('.car-sig'), n = items.length;
    items.forEach(function (f, i) { f.setAttribute('role', 'group'); f.setAttribute('aria-roledescription', 'page'); f.setAttribute('aria-label', (i + 1) + ' sur ' + n); });
    // Referencia: el centro (móvil, páginas centradas) o el borde izquierdo con su relleno (escritorio, alineadas al inicio)
    function alInicio() { return getComputedStyle(items[0]).scrollSnapAlign.indexOf('start') === 0; }
    function relleno() { return parseFloat(getComputedStyle(pista).paddingLeft) || 0; }
    function actual() {
      var ini = alInicio(), ref = ini ? pista.scrollLeft + relleno() : pista.scrollLeft + pista.clientWidth / 2, mejor = 0, md = 1e9;
      items.forEach(function (f, i) { var dd = Math.abs((ini ? f.offsetLeft : f.offsetLeft + f.offsetWidth / 2) - ref); if (dd < md) { md = dd; mejor = i; } });
      return mejor;
    }
    function ir(i) {
      i = clamp(i, 0, n - 1); var f = items[i];
      var izq = alInicio() ? f.offsetLeft - relleno() : f.offsetLeft - (pista.clientWidth - f.offsetWidth) / 2;
      pista.scrollTo({ left: izq, behavior: reducir ? 'auto' : 'smooth' });
    }
    ant.addEventListener('click', function () { ir(actual() - 1); });
    sig.addEventListener('click', function () { ir(actual() + 1); });
    var ultimo = '';
    function estado() {
      var i = actual();
      var fin = pista.scrollLeft >= pista.scrollWidth - pista.clientWidth - 4;
      var ult = i;
      if (alInicio()) items.forEach(function (f, k) { if (f.offsetLeft + f.offsetWidth <= pista.scrollLeft + pista.clientWidth + 4) ult = Math.max(ult, k); });
      var txt = (ult > i ? (i + 1) + '–' + (ult + 1) : (i + 1)) + ' / ' + n;
      if (txt !== ultimo) { cuenta.textContent = txt; ultimo = txt; }
      ant.disabled = i === 0; sig.disabled = i === n - 1 || fin;
    }
    // Abanico: e = 0 (páginas juntas y giradas) → 1 (desplegadas), ligado al scroll y suavizado; luego «coverflow» suave.
    var e = reducir ? 1 : 0, eObj = e, vivo = false;
    function pinta() {
      estado();
      if (reducir) return;
      var c = pista.scrollLeft + pista.clientWidth / 2, ab = 1 - e;
      items.forEach(function (f, k) {
        var w = f.offsetWidth, m = f.offsetLeft + w / 2, dd = clamp((m - c) / w, -2, 2), a = Math.min(Math.abs(dd), 1);
        var tx = -(m - c) * 0.62 * ab, rot = -dd * 3 * e + (k - (n - 1) / 2) * 5 * ab, s = 1 - a * 0.08 * e;
        cartas[k].style.transform = 'translateX(' + tx.toFixed(1) + 'px) rotate(' + rot.toFixed(2) + 'deg) scale(' + s.toFixed(3) + ')';
        cartas[k].style.zIndex = n - Math.round(Math.abs(dd) * 2);
      });
    }
    function bucle() {
      var dl = eObj - e; if (Math.abs(dl) > 0.002) { e += dl * 0.1; vivo = true; } else { e = eObj; vivo = false; }
      pinta(); if (vivo) requestAnimationFrame(bucle);
    }
    function arranca() { if (!vivo) { vivo = true; requestAnimationFrame(bucle); } }
    pista.addEventListener('scroll', porFotograma(pinta), { passive: true });
    W.addEventListener('resize', porFotograma(pinta));
    if (!reducir) {
      var alScroll = porFotograma(function () {
        var r = el.getBoundingClientRect(), vh = W.innerHeight;
        var o = clamp((vh * 0.98 - r.top) / (vh * 0.45), 0, 1);
        if (o !== eObj) { eObj = o; arranca(); }
      });
      W.addEventListener('scroll', alScroll, { passive: true });
      var r0 = el.getBoundingClientRect(); e = eObj = clamp((W.innerHeight * 0.98 - r0.top) / (W.innerHeight * 0.45), 0, 1);
    }
    pinta();
    // Arrastrar con el ratón (en táctil, el desplazamiento nativo ya lo hace)
    if (fino) {
      var arr = null, movido = false;
      pista.addEventListener('pointerdown', function (ev) { if (ev.pointerType !== 'mouse' || ev.button !== 0) return; arr = { x: ev.clientX, s: pista.scrollLeft }; movido = false; });
      W.addEventListener('pointermove', function (ev) {
        if (!arr) return; var dx = ev.clientX - arr.x;
        if (!movido && Math.abs(dx) > 6) { movido = true; el.classList.add('arrastrando'); }
        if (movido) pista.scrollLeft = arr.s - dx;
      });
      W.addEventListener('pointerup', function () { if (!arr) return; arr = null; if (movido) { el.classList.remove('arrastrando'); ir(actual()); setTimeout(function () { movido = false; }, 0); } });
      pista.addEventListener('click', function (ev) { if (movido) { ev.preventDefault(); ev.stopPropagation(); } }, true);
      pista.addEventListener('dragstart', function (ev) { ev.preventDefault(); });
    }
  });

  /* ---------- 4b · visor: versión grande + zoom al tocar ---------- */
  (function () {
    var lb = d.getElementById('lb'), img = d.getElementById('lb-img'), bz = d.getElementById('lb-zoom');
    if (!lb || !img) return;
    var caja = d.createElement('div'); caja.className = 'lb-zoom';
    img.parentNode.insertBefore(caja, img); caja.appendChild(img);
    var minis = $$('[data-lb] img[data-grande]');
    function grande() {
      var s = img.getAttribute('src'); if (!s) return;
      minis.forEach(function (m) {
        var g = m.getAttribute('data-grande');
        if (s !== g && (s === m.currentSrc || s === m.src || s === m.getAttribute('src'))) img.setAttribute('src', g);
      });
    }
    function zoom(on, ev) {
      var r = img.getBoundingClientRect(), fx = 0.5, fy = 0.3;
      if (ev && r.width) { fx = (ev.clientX - r.left) / r.width; fy = (ev.clientY - r.top) / r.height; }
      lb.classList.toggle('zoom', on);
      if (bz) { bz.setAttribute('aria-pressed', on ? 'true' : 'false'); bz.setAttribute('aria-label', on ? 'Réduire la page' : 'Zoomer sur la page'); bz.textContent = on ? '−' : '+'; }
      if (on) requestAnimationFrame(function () { caja.scrollLeft = fx * caja.scrollWidth - caja.clientWidth / 2; caja.scrollTop = fy * caja.scrollHeight - caja.clientHeight / 2; });
    }
    new MutationObserver(function () { grande(); if (lb.classList.contains('zoom')) zoom(false); }).observe(img, { attributes: true, attributeFilter: ['src'] });
    img.addEventListener('click', function (ev) { zoom(!lb.classList.contains('zoom'), ev); });
    if (bz) bz.addEventListener('click', function () { zoom(!lb.classList.contains('zoom')); });
    lb.addEventListener('close', function () { zoom(false); });
  })();

  /* ---------- 5 · cartas que se giran ---------- */
  $$('[data-mo="cartas"] .carta').forEach(function (b) {
    b.addEventListener('click', function () { b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); });
  });
})();
